<script>
import bem from '@/utils/bem';
import { mapState } from 'vuex';
import PlaceholderImageSelector from '@/components/frames/PlaceholderImageSelector.vue';

const b = bem('template-frame-option-displays');

export default {
  data() {
    return {
      selectedOption: null,
      show: false,
      test: 1,
    };
  },
  props: {
    frameImageOptions: Array,
    frameRotateX: Number,
    frameRotateY: Number,
    frameRotateZ: Number,
    framePerspective: Number,
    framePerspectiveOriginX: Number,
    framePerspectiveOriginY: Number,
  },
  components: {
    PlaceholderImageSelector,
  },
  methods: {
    b(firstArg, secondArg) {
      return b(firstArg, secondArg);
    },
    change({ target: { value } }, type) {
      this.$emit(`update:${type}`, value);
    },
    clickChangeImage(id) {
      this.selectedOption = id;
      this.show = true;
    },
  },
  computed: {
    ...mapState({
      collagePreviewImage: (state) => state.createTemplate.collagePreviewImage,
      frameDetails: (state) => state.createTemplate.frameDetails,
    }),
  },
};
</script>

<template>
  <div :class="b('view-boxes')">
    <div
        :class="b('view-box')"
        v-for="(frameImage, index) in frameImageOptions"
        :key="frameImage.id"
    >
      <span>{{ `View box #${index + 1}` }}</span>
      <div :class="b('row')">
        <div :class="b('modal-input', { row: true })">
          <span :class="b('modal-input-title')">X:</span>
          <a-input
              type="number"
              v-model:value="frameImage.x"
          />
        </div>
        <div :class="b('modal-input', { row: true })">
          <span :class="b('modal-input-title')">Y:</span>
          <a-input
              type="number"
              v-model:value="frameImage.y"
          />
        </div>
      </div>
      <div :class="b('row')">
        <div :class="b('modal-input', { row: true })">
          <span :class="b('modal-input-title')">Width:</span>
          <a-input
              type="number"
              v-model:value="frameImage.width"
          />
        </div>
        <div :class="b('modal-input', { row: true })">
          <span :class="b('modal-input-title')">Height:</span>
          <a-input
              type="number"
              v-model:value="frameImage.height"
          />
        </div>
      </div>
      <div :class="b('row')">
        <a-button
          v-if="frameDetails?.name === 'collage'"
          type="primary"
          size="small"
          html-type="button"
          @click="clickChangeImage(frameImage.id)"
        >
          Change image
        </a-button>
        <placeholder-image-selector
          v-if="selectedOption === frameImage.id"
          v-model:show="show"
          v-model:imageId="frameImage.imageId"
          :images="collagePreviewImage || []"
        />
      </div>
    </div>
  </div>
  <div :class="b('other-settings')">
    <div :class="b('setting-input')">
      <div :class="b('row')">
        <span :class="b('modal-input-title')">Rotate X:</span>
        <a-input
            type="number"
            :value="frameRotateX"
            @change="(e) => {change(e, 'frameRotateX')}"
            :min="-180" :max="180"
        />
      </div>
      <a-slider
          :value="frameRotateX"
          :min="-180" :max="180"
          @change="(e) => {change({target: {value: e}}, 'frameRotateX')}"
      />
    </div>
    <div :class="b('setting-input')">
      <div :class="b('row')">
        <span :class="b('modal-input-title')">Rotate Y:</span>
        <a-input
            type="number"
            @change="(e) => {change(e, 'frameRotateY')}"
            :value="frameRotateY"
            :min="-180" :max="180"
        />
      </div>
      <a-slider
          :value="frameRotateY"
          :min="-180" :max="180"
          @change="(e) => {change({target: {value: e}}, 'frameRotateY')}"
      />
    </div>
    <div :class="b('setting-input')">
      <div :class="b('row')">
        <span :class="b('modal-input-title')">Rotate Z:</span>
        <a-input
            type="number"
            :value="frameRotateZ"
            @change="(e) => {change(e, 'frameRotateZ')}"
            :min="-180" :max="180"
        />
      </div>
      <a-slider
         :value="frameRotateZ"
         :min="-180" :max="180"
         @change="(e) => {change({target: {value: e}}, 'frameRotateZ')}"
      />
    </div>
    <div :class="b('setting-input')">
      <div :class="b('row')">
        <span :class="b('modal-input-title')">Perspective:</span>
        <a-input
            type="number"
            @change="(e) => {change(e, 'framePerspective')}"
            :value="framePerspective"
            :min="0" :max="1500"
        />
      </div>
      <a-slider
          :value="framePerspective"
          :min="0" :max="1500"
          @change="(e) => {change({target: {value: e}}, 'framePerspective')}"
      />
    </div>
    <div :class="b('setting-input')">
      <div :class="b('row')">
        <span :class="b('modal-input-title')">Perspective origin X:</span>
        <a-input
            type="number"
            :value="Number(framePerspectiveOriginX)"
            @change="(e) => {change(e, 'framePerspectiveOriginX')}"
            :min="0" :max="100"
        />
      </div>
      <a-slider
          :value="Number(framePerspectiveOriginX)"
          @change="(e) => {change({target: {value: e}}, 'framePerspectiveOriginX')}"
          :min="0" :max="100"
      />
    </div>
    <div :class="b('setting-input')">
      <div :class="b('row')">
        <span :class="b('modal-input-title')">Perspective origin Y:</span>
        <a-input
            type="number"
            :value="Number(framePerspectiveOriginY)"
            @change="(e) => {change(e, 'framePerspectiveOriginY')}"
            :min="0" :max="100"
        />
      </div>
      <a-slider
          :value="Number(framePerspectiveOriginY)"
          @change="(e) => {change({target: {value: e}}, 'framePerspectiveOriginY')}"
          :min="0" :max="100"
      />
    </div>
  </div>
</template>

<style scoped lang="scss" src="./templateFrameOptionDisplays.scss"></style>
